﻿import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { OnDestroy } from "@angular/core/src/metadata/lifecycle_hooks";
import { SafeUrl, SafeResourceUrl } from "@angular/platform-browser";
import { DomSanitizer } from "@angular/platform-browser";
import { ReportModel } from "../models/ReportModel";
import { SafeHtml } from "@angular/platform-browser/src/security/dom_sanitization_service";
import { Configuration } from "../app.constants";

@Component({
    selector: 'report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit, OnDestroy {
    private sub: any;
    private conversionId: string;
    public report: ReportModel;
    public downloadUrl: SafeResourceUrl;
    public downloadReportUrl: SafeResourceUrl;
    public reportHtml: string;
    public validationMessage: string;
    public showValidationMessage: boolean;
    public isBusy: boolean;  
    public canGenerateExcel: boolean;

    constructor(private _http: HttpClient, private route: ActivatedRoute, private _sanitizer: DomSanitizer, private _router:Router, private _config:Configuration) {
    }

    ngOnInit(): void {
        let validate = this.route.snapshot.queryParams.validate == "true";
        console.log(`Validate: ${validate}`);
        this.sub = this.route.params.subscribe(params => {
            this.conversionId = params['conversionId'];

            this._http.get<ReportModel>(`${this._config.Server}/api/conversion/${this.conversionId}/report?json=true`).subscribe(report => {

                if (report.size > 1000000) {
                    report.reportType = "download";
                } else if (report.html == null) {
                    report.reportType = "noReport";
                } else {
                    this.reportHtml = report.html;
                }

                //if (report.secondsElapsed > 0) {
                //    let minutes: string,
                //        seconds: string;

                //    minutes = Math.floor(report.secondsElapsed / 60).toString();
                //    seconds = ((report.secondsElapsed % 60)).toFixed(0);
                //    this.elapsed = "(" + minutes + ':' + (+seconds < 10 ? '0' : '') + seconds + ")";
                //}

                this.report = report;
            });
            this.downloadUrl = this._sanitizer.bypassSecurityTrustResourceUrl(`${this._config.Server}/api/conversion/${this.conversionId}/xbrl`);
            this.downloadReportUrl = this._sanitizer.bypassSecurityTrustResourceUrl(`${this._config.Server}/api/conversion/${this.conversionId}/report?asFile=true`);
        });    
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    back() {
        this._router.navigateByUrl("/");
    }

    validate() {
        this.isBusy = true;
        this.showValidationMessage = true;

        const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');

        this._http.post(`${this._config.Server}/api/conversion/${this.conversionId}/validate`, null, { headers, responseType: 'text' }).subscribe(message => {
            this.isBusy = false;
            this.validationMessage = <string>message;
        });
    }
}